import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { ISell, States } from 'safe'
import { transformTime, transformTimeBySpaces } from '../../utils/utils'
import { CLEAN_SELLS, SellsTypes, SET_SELLS } from './actionTypes'

const server = process.env.REACT_APP_SERVER_URL

export const setSells = (sells: States.Sells): SellsTypes => ({
  type: SET_SELLS,
  payload: sells,
})

export const cleanSells = (): SellsTypes => ({
  type: CLEAN_SELLS,
})

export const fetchSells =
  (
    querySearch: string[],
    paginationParams: string[] = []
  ): ThunkAction<Promise<void>, {}, {}, SellsTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, SellsTypes>): Promise<void> => {
    try {
      /* Any mientras tanto */
      const response: AxiosResponse<{
        status: number
        sales: any[]
        numberOfPages: number
      }> = await axios.get(
        `${server}/sale?${[
          ...querySearch,
          ...paginationParams,
        ].join('&')}`
      )

      // console.log(allCompletedSalesByInvoice.map((sale) => Math
      //   .floor(new Date(sale.finished_date).getTime() / 1000.0)))
      // response.data.sales.map((sale) => {
      //   console.log('finish', sale.finishedDate)
      //   console.log(
      //     'SALE DATE',
      //     Math.floor(new Date(sale.finishedDate).getTime() / 1000.0)
      //   )
      //   console.log(
      //     'epoch',
      //     new Date(
      //       Math.floor(new Date(sale.finishedDate).getTime() / 1000.0) * 1000
      //     ).toLocaleTimeString()
      //   )
      // })

      dispatch(
        setSells({
          sells: response.data.sales,
          numberOfPages: response.data.numberOfPages,
        })
      )
    } catch (error) {
      throw error
    }
  }

export const fetchFreeForms =
  (
    querySearch: string[],
    paginationParams: string[] = []
  ): ThunkAction<Promise<void>, {}, {}, SellsTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, SellsTypes>): Promise<void> => {
    try {
      /* Any mientras tanto */
      const resp: AxiosResponse<{
        status: number
        sales: any[]
        numberOfPages: number
      }> = await axios.get(
        `${server}/business/sale/free-form?${[
          ...querySearch,
          ...paginationParams,
        ].join('&')}`
      )

      dispatch(
        setSells({
          sells: resp.data.sales.map((sale) => ({
            ...sale,
            numberOfItems: sale.type === 'FREE FORM' ? sale.freeForm.freeFormDetail.items.length : sale.invoice.invoiceDetail.items.length,
            invoice: sale.freeForm,
            fixedDate: transformTimeBySpaces(
              new Date(
                Math.floor(new Date(sale.finishedDate).getTime() / 1000.0) *
                  1000
              ) + ''
            ),
          })),
          numberOfPages: resp.data.numberOfPages,
        })
      )
    } catch (error) {
      throw error
    }
  }
